import type {OrderDetailData} from 'modules/Orders/types';

import {LeftOutlined} from '@ant-design/icons';
import {dateToReadableDate} from '@date-picker';
import OrderDataRow from 'modules/Orders/components/common/OrderDataRow/OrderDataRow';
import {numberFormat} from 'utils/Helper';

type OrderStatusDetailsProps = {
  order?: OrderDetailData;
  onInvoiceClick: () => void;
};

const OrderStatusDetails: React.FC<OrderStatusDetailsProps> = ({order, onInvoiceClick}) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
      <button
        type="button"
        className="flex min-h-11 w-full items-center justify-between gap-3 border-b border-gray-03 px-2.5 py-2 text-body-md-emphasis"
        onClick={onInvoiceClick}
      >
        <span className="text-gray-07">جزییات سفارش</span>
        <span className="flex items-center gap-1.25 text-gray-09">
          مشاهده فاکتور
          <LeftOutlined className="text-xl" aria-hidden />
        </span>
      </button>
      <OrderDataRow title="نام مشتری" value={order?.customer_name} />
      <OrderDataRow title="کد سفارش" value={order?.order_code} />
      <OrderDataRow
        title="زمان ثبت سفارش"
        value={dateToReadableDate({
          date: order?.order_date ?? '',
          day: true,
          month: true,
          year: true,
          hour: true,
          minute: true
        })}
      />
      <OrderDataRow
        title="فروش شما"
        value={`${numberFormat(order?.vendor_revenue || 0)} تومان`}
      />
      <OrderDataRow title="توضیحات مشتری" value={order?.customer_comment || '_'} />
    </div>
  );
};

export default OrderStatusDetails;
